import { ConstructFromIterableObservable, IS_FROM_ITERABLE_OBSERVABLE_CONSTRUCTOR } from './constructor';
import { GetSetSuperArgsFunction, IsFactoryClass, MakeFactory } from '../../../../../../classes/class-helpers/factory';
import { GenerateFiniteStateObservableHookFromIterableWithPauseWorkflow } from './hook-generators';
import { FiniteStateObservableFactory } from '../../../implementation';
import { NotificationsObservableFactory } from '../../../../../core/notifications-observable/implementation';
import { ObservableFactory } from '../../../../../../core/observable/implementation';
import { BaseClass } from '../../../../../../classes/class-helpers/base-class';
import { IsFiniteStateObservableConstructor } from '../../../constructor';
import { NormalizeFromIterableObservableOptionsAndIterable } from './functions';
export function PureFromIterableObservableFactory(superClass) {
    if (!IsFiniteStateObservableConstructor(superClass)) {
        throw new TypeError(`Expected FiniteStateObservableConstructor as superClass`);
    }
    const setSuperArgs = GetSetSuperArgsFunction(IsFactoryClass(superClass));
    return class FromIterableObservable extends superClass {
        constructor(...args) {
            const [iterable, options] = args[0];
            const normalizedArgs = NormalizeFromIterableObservableOptionsAndIterable(iterable, options);
            super(...setSuperArgs(args.slice(1), [
                GenerateFiniteStateObservableHookFromIterableWithPauseWorkflow(iterable, normalizedArgs.isAsync),
                normalizedArgs
            ]));
            ConstructFromIterableObservable(this, normalizedArgs);
        }
    };
}
export let FromIterableObservable;
export function FromIterableObservableFactory(superClass) {
    return MakeFactory(PureFromIterableObservableFactory, [], superClass, {
        name: 'FromIterableObservable',
        instanceOf: FromIterableObservable,
        waterMarks: [IS_FROM_ITERABLE_OBSERVABLE_CONSTRUCTOR],
    });
}
export function FromIterableObservableBaseFactory(superClass) {
    return MakeFactory(PureFromIterableObservableFactory, [FiniteStateObservableFactory, NotificationsObservableFactory, ObservableFactory], superClass, {
        name: 'FromIterableObservable',
        instanceOf: FromIterableObservable,
        waterMarks: [IS_FROM_ITERABLE_OBSERVABLE_CONSTRUCTOR],
    });
}
FromIterableObservable = class FromIterableObservable extends FromIterableObservableBaseFactory(BaseClass) {
    constructor(iterable, options) {
        super([iterable, options], [], [], []);
    }
};
//# sourceMappingURL=implementation.js.map